import { render, staticRenderFns } from "./SidebarFilter.vue?vue&type=template&id=f1108608&scoped=true"
import script from "./SidebarFilter.vue?vue&type=script&lang=js"
export * from "./SidebarFilter.vue?vue&type=script&lang=js"
import style0 from "./SidebarFilter.vue?vue&type=style&index=0&id=f1108608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1108608",
  null
  
)

export default component.exports